import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

/**
 * Symbol data access: Firestore first, bundled JSON as fallback.
 *
 * The Python pipeline mirrors every local export to /web_{kind}/{SYMBOL}, so
 * the deployed site gets hourly data with no hosting deploy. The bundled
 * /data/{kind}/{SYMBOL}.json (same bytes, written first) covers local dev,
 * Firestore outages, and the window before the first mirror ran — a Firestore
 * problem degrades to stale-but-working, never to a blank page.
 */
export async function fetchSymbolData(kind, symbol) {
  try {
    const snap = await getDoc(doc(db, `web_${kind}`, symbol));
    if (snap.exists()) return snap.data();
  } catch (e) {
    // fall through to the bundled copy
  }
  const r = await fetch(`/data/${kind}/${symbol}.json`, { cache: "no-cache" });
  if (!r.ok) throw new Error(`no ${kind} data for ${symbol}`);
  return r.json();
}

/** UTC instant -> the viewer's local date+time, short form. */
export function fmtLocal(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString([], {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit",
  });
}
